import * as helios from "@hyperionbt/helios";

export function sleep(ms: number): Promise<void> {
  return new Promise<void>((resolve) => setTimeout(() => resolve(), ms));
}

export async function waitUntil<T = boolean>(predicate: () => Promise<T>) {
  for (let interval = 1000; true; interval += 1000) {
    await sleep(interval);
    const result = await predicate();
    if (result) {
      return result;
    }
  }
}

export async function waitForUtxo(
  cip30Wallet: helios.Cip30Wallet,
  predicate: (utxo: helios.UTxO) => boolean
) {
  for (let i = 0; true; i++) {
    await new Promise((resolve) => setTimeout(resolve, i * 1000));
    const utxos = await cip30Wallet.utxos;
    const found = utxos.some((utxo) => predicate(utxo));
    if (found) break;
  }
}
